import Button from './Button';
import FloatingButton from './FloatingButton';

Button.Floating = FloatingButton;
export { FloatingButton };
export default Button;
